// extracted by mini-css-extract-plugin
export var bodySections = "_4b-8";
export var gray = "_4b-7";
export var green = "_4b-4";
export var iconContainer = "_4b-9";
export var iconWidgetContainer = "_4b-1";
export var phoneIcon = "_4b-2";
export var red = "_4b-5";
export var statusDot = "_4b-3";
export var widgetContainer = "_4b-0";
export var yellow = "_4b-6";